import PropTypes from "prop-types";
import React from 'react'
import { useTranslation } from 'react-i18next';
import config from "../../config";

const NoStaffAccessPage = (props) => {
  const {t} = useTranslation();
  return (
    <div className="page-content">
      <div className={`${props && props.center ? "loader-spinner-center" : ""}`}>
      <div className={`complete-box text-center d-flex flex-column justify-content-center my-md-5 my-4 ${props && props.nostaffbackgroundchange ? "bg-white" : "bg-cream"}`}>
        <div className="complete-box-wrp text-center ">
          <img src={config.imagepath + "user-girls.png"} alt="" className="mb-md-4 mb-3" />
          <h4 className="mb-2 fw-semibold">
          {t("As a Staff Member")}<br/>
            {t("You don't have access to this module.")}
          </h4>
        </div>
      </div>
    </div>
    </div>
  )
}

NoStaffAccessPage.propTypes = {
  center: PropTypes.bool,
  nostaffbackgroundchange: PropTypes.bool,
};

export default NoStaffAccessPage;
